import { hasProperties, IsInterface, isLikeObject, isSingletonString, isUnknown } from "generic-type-guard";
export function isMap(ptt) {
    return new IsInterface().withStringIndexSignature(ptt, false).get();
}
export function isMapEntry(check) {
    return (entry) => check(entry[1]);
}
function isStaticDescriptor(descriptor) {
    return isLikeObject(Object.fromEntries(Object.entries(descriptor).map(([key, value]) => [key, isSingletonString(value)])));
}
function isAbsent(...keys) {
    return (obj) => isMap(isUnknown)(obj) && keys.every(key => obj[key] === undefined);
}
export function createDescriptorFunctions(staticProps, dynamicProps, absentProps = []) {
    return {
        isInstance: new IsInterface()
            .with(isStaticDescriptor(staticProps))
            .with(hasProperties(dynamicProps))
            .with(isAbsent(...absentProps))
            .get(),
        build(props) {
            return { ...props, ...staticProps };
        }
    };
}
